import { AuthorizationError, AuthenticationError, ValidationError, SystemError } from './errors';
import { toCamel } from '../utils/caseConverter';

function normalize(segment) {
	segment = segment || '';
	return segment.replace(/(^\/(?!\/))|(\/+$)/g, '');
}

export function combineUrl(...parts) {
	return parts.map(normalize).join('/');
}

export function handleErrors(response, conversions) {
	if (!response.ok) {
		const { status } = response;
		if (status === 400) {
			return normalizeResponse(response, conversions)
				.then((err) => extractValidationErrors(err, conversions))
				.then((err) => {
					throw new ValidationError(err);
				});
		}
		if (status === 401) {
			return normalizeResponse(response, conversions).then((err) => {
				throw new AuthenticationError(err);
			});
		}
		if (status === 403) {
			return normalizeResponse(response, conversions).then((err) => {
				throw new AuthorizationError(err);
			});
		}
		if (status >= 500) {
			throw new SystemError(response.statusText);
		}
		throw new Error(response.statusText);
	}
	return response;
}

export function normalizeResponse(response, explicitMappings) {
	if (response.status === String(204)) return '';

	return response.json().then((json) => toCamel(json, explicitMappings));
}

function extractValidationErrors(modelState, conversions) {
	const errors = {};
	for (var prop in modelState) {
		if (modelState.hasOwnProperty(prop) && prop !== '$id') {
			for (var errorProp in modelState[prop]) {
				if (errorProp.indexOf('.') === -1) {
					errors._error = modelState[prop][errorProp];
				} else {
					let fieldName = errorProp.replace(/\w+\./, '');
					if (conversions && conversions[fieldName] !== undefined) {
						fieldName = conversions[fieldName];
					}
					errors[fieldName] = modelState[prop][errorProp];
				}
			}
		}
	}
	return errors;
}

export function service(apiUrl, relativePath) {
	return combineUrl(apiUrl, relativePath);
}
